// 개인정보 관리 페이지 JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // 해당 페이지 체크 (핵심 요소 존재 확인)
  const nameInput = document.getElementById('name');
  if (!nameInput) {
    return; // 개인정보 관리 페이지가 아니면 종료
  }
  // 사용자 정보 로드
  loadUserInfo();
  
  // 이메일 도메인 변경 핸들러
  setupEmailDomainHandler();
});

// 사용자 정보 로드
function loadUserInfo() {
  // TODO: 실제 API 연동 시 사용자 정보를 가져와서 표시
  // 임시 데이터
  const userData = {
    name: '홍길동',
    postcode: '06000',
    address1: '서울특별시 강남구 테헤란로 123',
    address2: '삼성빌딩 10층',
    email: 'user@example.com',
    phone: '010-1234-5678'
  };
  
  // 기본 정보 표시 (상단 읽기 전용)
  document.getElementById('displayName').value = userData.name;
  document.getElementById('displayPostcode').value = userData.postcode;
  document.getElementById('displayAddress1').value = userData.address1;
  document.getElementById('displayAddress2').value = userData.address2;
  document.getElementById('displayEmail').value = userData.email;
  document.getElementById('displayPhone').value = userData.phone;
  
  // 수정 폼에 현재 정보 미리 채우기
  document.getElementById('customerName').value = userData.name;
  document.getElementById('postcode').value = userData.postcode;
  document.getElementById('address1').value = userData.address1;
  document.getElementById('address2').value = userData.address2;
  
  // 이메일 분리
  const emailParts = userData.email.split('@');
  if (emailParts.length === 2) {
    document.getElementById('emailId').value = emailParts[0];
    const domain = emailParts[1];
    const domainSelect = document.getElementById('emailDomain');
    
    // 도메인이 옵션에 있는지 확인
    let foundDomain = false;
    for (let i = 0; i < domainSelect.options.length; i++) {
      if (domainSelect.options[i].value === domain) {
        domainSelect.value = domain;
        foundDomain = true;
        break;
      }
    }
    
    // 옵션에 없으면 직접입력으로 설정
    if (!foundDomain) {
      domainSelect.value = 'direct';
      document.getElementById('emailDomainSelectWrapper').style.display = 'none';
      document.getElementById('emailDomainInput').style.display = 'block';
      document.getElementById('emailDomainInput').value = domain;
    }
  }
  
  document.getElementById('phoneNumber').value = userData.phone.replace(/-/g, '');
  
  // 초기에는 모든 입력 필드 비활성화 (읽기 전용 스타일)
  disableAllEditFields();
}

// 모든 수정 필드를 읽기 전용으로 설정
function disableAllEditFields() {
  const editFields = ['customerName', 'address2', 'emailId', 'phoneNumber'];
  editFields.forEach(fieldId => {
    const field = document.getElementById(fieldId);
    if (field) {
      field.style.backgroundColor = '#f8f9fa';
      field.style.cursor = 'pointer';
      field.setAttribute('readonly', 'true');
    }
  });
  
  // emailDomainInput도 처리
  const emailDomainInput = document.getElementById('emailDomainInput');
  if (emailDomainInput && emailDomainInput.style.display !== 'none') {
    emailDomainInput.style.backgroundColor = '#f8f9fa';
    emailDomainInput.style.cursor = 'pointer';
    emailDomainInput.setAttribute('readonly', 'true');
  }
}

// 입력 필드 활성화 (클릭 시)
function enableEdit(element) {
  element.style.backgroundColor = '#fff';
  element.style.cursor = 'text';
  element.removeAttribute('readonly');
  element.focus();
}

// 전화번호 인증 요청
let phoneVerified = false;
function requestPhoneVerification() {
  const phoneNumber = document.getElementById('phoneNumber').value;
  
  if (!phoneNumber) {
    alert('전화번호를 입력해주세요.');
    return;
  }
  
  // 전화번호 형식 검증
  const phonePattern = /^01[0-9]{8,9}$/;
  if (!phonePattern.test(phoneNumber.replace(/-/g, ''))) {
    alert('올바른 전화번호 형식이 아닙니다.');
    return;
  }
  
  // TODO: 실제 API 연동 - SMS 인증번호 발송
  
  // 임시 처리
  phoneVerified = true;
  document.getElementById('phoneVerificationMessage').style.display = 'block';
  alert('휴대폰 인증이 완료되었습니다.\n(개발 모드: 자동 인증)');
}

// 이메일 도메인 핸들러 설정
function setupEmailDomainHandler() {
  // 이미 HTML에서 onchange 이벤트로 연결됨
}

// 이메일 도메인 변경 처리
function handleEmailDomainChange() {
  const selectElement = document.getElementById('emailDomain');
  const inputElement = document.getElementById('emailDomainInput');
  const selectWrapper = document.getElementById('emailDomainSelectWrapper');
  
  if (selectElement.value === 'direct') {
    selectWrapper.style.display = 'none';
    inputElement.style.display = 'block';
    inputElement.style.backgroundColor = '#f8f9fa';
    inputElement.style.cursor = 'pointer';
    inputElement.setAttribute('readonly', 'true');
    inputElement.focus();
  } else {
    selectWrapper.style.display = 'block';
    inputElement.style.display = 'none';
  }
}

// 주소 검색 (Daum 우편번호 API)
function openPostcodeSearch() {
  new daum.Postcode({
    oncomplete: function(data) {
      // 우편번호와 주소 정보를 해당 필드에 넣는다.
      document.getElementById('postcode').value = data.zonecode;
      
      let addr = ''; // 주소 변수
      
      // 사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
      if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
        addr = data.roadAddress;
      } else { // 사용자가 지번 주소를 선택했을 경우(J)
        addr = data.jibunAddress;
      }
      
      document.getElementById('address1').value = addr;
      
      // 상세주소 필드 활성화 및 포커스
      const address2 = document.getElementById('address2');
      enableEdit(address2);
      address2.focus();
    }
  }).open();
}

// 전체 정보 수정
function updateProfile() {
  // 수정된 정보 수집
  const updatedData = {
    name: document.getElementById('customerName').value,
    postcode: document.getElementById('postcode').value,
    address1: document.getElementById('address1').value,
    address2: document.getElementById('address2').value,
    emailId: document.getElementById('emailId').value,
    emailDomain: document.getElementById('emailDomain').value === 'direct' 
      ? document.getElementById('emailDomainInput').value 
      : document.getElementById('emailDomain').value,
    phone: document.getElementById('phoneNumber').value
  };
  
  // 유효성 검사
  if (!updatedData.name) {
    alert('성명을 입력해주세요.');
    return;
  }
  
  if (!updatedData.postcode || !updatedData.address1) {
    alert('주소를 입력해주세요.');
    return;
  }
  
  if (!updatedData.emailId || !updatedData.emailDomain) {
    alert('이메일을 입력해주세요.');
    return;
  }
  
  // 이메일 형식 검증
  const fullEmail = updatedData.emailId + '@' + updatedData.emailDomain;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(fullEmail)) {
    alert('올바른 이메일 형식이 아닙니다.');
    return;
  }
  
  if (!updatedData.phone) {
    alert('휴대폰 번호를 입력해주세요.');
    return;
  }
  
  // 전화번호 인증 확인
  if (!phoneVerified) {
    alert('휴대폰 인증을 완료해주세요.');
    return;
  }
  
  // TODO: 실제 API 연동
  
  // 임시 처리 - 상단 표시 영역 업데이트
  const phoneFormatted = updatedData.phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  
  document.getElementById('displayName').value = updatedData.name;
  document.getElementById('displayPostcode').value = updatedData.postcode;
  document.getElementById('displayAddress1').value = updatedData.address1;
  document.getElementById('displayAddress2').value = updatedData.address2;
  document.getElementById('displayEmail').value = fullEmail;
  document.getElementById('displayPhone').value = phoneFormatted;
  
  alert('개인정보가 수정되었습니다.');
  
  // 입력 필드 다시 비활성화
  disableAllEditFields();
  
  // 인증 메시지 숨기기
  phoneVerified = false;
  document.getElementById('phoneVerificationMessage').style.display = 'none';
}

